import React, { useRef, useState } from "react";
import "./About.css";
import aboutImg from "../Assets/Logo/Adson.jpg"; // Replace with your image
import aboutVideo1 from "../Assets/About/About2.mp4"; // Replace with your video



export default function About() {
  return (
    <section className="about" id="about">
      <div className="about__inner">
        {/* Left - Image */}
        <div className="about__videos">
          <video src={aboutVideo1} controls muted loop className="about-video"></video>
        </div>


        {/* Right - Content */}
        <div className="about__content">
          <h2 className="about__title">About <span>AdsOn</span></h2>
          <p className="about__text">
            At AdsOn Agency, we specialize in creating high-impact advertising 
            strategies across all major platforms — from TikTok and YouTube to 
            Google, Facebook, and Instagram. Our mission is simple: 
            <strong> boost your brand and maximize ROI.</strong>
          </p>
          <ul className="about__list">
            <li>✔ Expert Team with Proven Results</li>
            <li>✔ Data-Driven Marketing Strategies</li>
            <li>✔ 24/7 Support & Fast Communication</li>
          </ul>
          <a href="#contact" className="btn btn-primary about__btn">Contact Us</a>
        </div>
      </div>
    </section>
  );
}
